import axios from "axios";

const baseConfig = {
  //  baseURL: "http://localhost:9000",
  baseURL: "",
  withCredentials: true,
};
let alertShown = false;
const baseService = {
  service: () => {
    const instance = axios.create(baseConfig);

    instance.interceptors.request.use(
      (config) => {
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    instance.interceptors.response.use(
      (response) => response,
      (error) => {
        /*  if (
          error.response &&
          (error.response.status === 401 || error.response.status === 403)
        ) {

          if (!alertShown) {    
            alert("Sesija istekla. Molimo Vas da se ponovo prijavite.");
            alertShown = true;   
            window.location.href = "/";
          }
        } */
        if (
          error.response &&
          (error.response.status === 401 || error.response.status === 403)
        ) {
          const currentPath = window.location.pathname;
          if (!currentPath.includes("/login")) {
            if (!alertShown) {
              alert("Sesija je istekla. Molimo Vas da se ponovo prijavite.");
              alertShown = true;
              window.location.href = "/";
            }
          }
        }
        return Promise.reject(error);
      }
    );

    instance.defaults.headers.common["Content-Type"] = "application/json";
    return instance;
  },
};
export default baseService;
